import { type ReactNode } from 'react';

import { Tag, type TagProps } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import { type UploadItem } from '@/hooks/useUploader';

type StatusTag = { color: TagProps['color']; icon: ReactNode; label: string };

const STATUS_TAG: Partial<Record<UploadItem['status'], StatusTag>> = {
  hashing: { color: 'default', icon: <Icon.Key />, label: 'Verificando arquivo' },
  exists: { color: 'success', icon: <Icon.CircleCheck />, label: 'Upload completo' },
  done: { color: 'success', icon: <Icon.CircleCheck />, label: 'Upload completo' },
  uploading: { color: 'processing', icon: <Icon.LoaderCircle className='animate-spin' />, label: 'Enviando arquivo' },
  idle: { color: 'warning', icon: <Icon.Clock className='animate-spin' />, label: 'Aguardando envio' },
  aborted: { color: 'error', icon: <Icon.CircleX />, label: 'Excluindo upload' },
  error: { color: 'error', icon: <Icon.CircleX />, label: 'Falha no upload' }
};

export const UploadInfo = ({ upload }: { upload: UploadItem }) => {
  const statusTag = STATUS_TAG[upload.status];

  return (
    <div className='flex flex-row gap-2'>
      <Tag icon={<Icon.File />} color='default' variant='filled' className='text-content-subtitle'>
        {((upload.file.size || upload.size || 0) / 1024).toFixed(0)}KB
      </Tag>

      <Tag icon={<Icon.CloudUpload />} color='default' variant='filled' className='text-content-subtitle'>
        {upload.progress.toFixed(0)}%
      </Tag>

      {statusTag && (
        <Tag icon={statusTag.icon} color={statusTag.color} variant='filled'>
          {statusTag.label}
        </Tag>
      )}
    </div>
  );
};
